// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-setting[data-v-05a393d0]{height:97vh;position:relative}.account-setting .Lists[data-v-05a393d0]{width:85%;margin:0 auto;text-align:initial;margin-top:1rem}.account-setting .img[data-v-05a393d0]{position:absolute;bottom:3rem;left:50%;transform:translateX(-50%)}", ""]);
// Exports
module.exports = exports;
